const n={config:{linkTypes:{anchor:!0}}};export{n as DEFAULTS};
//# sourceMappingURL=defaults.js.map
